<template>
  <v-autocomplete v-model="user" :search-input.sync="search" :items="items"
                  cache-items
                  hide-details="auto"
                  hide-selected
                  @change="$emit('driver-changed', $event)"
                  :loading="items.length === 0"
                  item-text="username" item-value="username"
                  :disabled="!isActive"
                  :error-messages="errors"
                  :filter="nameEmailFilter"
                  :label="$vuetify.lang.t('$vuetify.carParks.driverForm.autocompleteTitle')">

    <template v-slot:item="data">
      <v-list-item-avatar v-if="data.item.isProfilePicture()" size="32">
        <v-img :src="data.item.profilePicture"></v-img>
      </v-list-item-avatar>
      <template v-if="data.item.username !== data.item.email">
        <v-list-item-content>
          <v-list-item-title>{{ data.item.username }}</v-list-item-title>
          <v-list-item-subtitle>{{ data.item.email }}</v-list-item-subtitle>
        </v-list-item-content>
      </template>
      <template v-else>
        <v-list-item-content>{{ data.item.email }}</v-list-item-content>
      </template>
    </template>

  </v-autocomplete>
</template>

<script>
import backend from '@/backend'
import { User } from '@/models/user/User'
import snackbarMixin from '@/mixins/snackbarMixin'

export default {
  name: 'singleDriverAutosearch',
  mixins: [snackbarMixin],
  props: {
    selectedDriver: {
      type: String,
      default: null
    },
    isActive: {
      type: Boolean,
      default: true
    },
    errors: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    user: null,
    items: [],
    search: null,
  }),
  async created () {
    try {
      const response = await backend.fetchDriverList()
      this.items = response.data.map(item => new User(item))

      if (this.selectedDriver !== null) {
        this.setDriver(this.selectedDriver)
      }
    } catch (e) {
      this.processFailedRequest(e)
    }
  },
  methods: {
    setDriver (username) {
      const driver = this.items.find(user => user.username === username)
      this.user = driver !== undefined ? driver.username : null
    },
    nameEmailFilter (item, queryText, itemText) {
      return (
        item.username.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) >
        -1 ||
        item.email.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1
      )
    }
  },
  watch: {
    selectedDriver (newValue) {
      if (newValue === '' || newValue === null) {
        this.user = null
      } else {
        this.setDriver(newValue)
      }
    }
  }
}
</script>

<style scoped>

</style>
